import type { IDependentControl, IRItemCard } from '~/presentation/reports/common/type';

import { EDependentControlAction } from '~/presentation/reports/common/type';
import { Banner, Text } from '@shopify/polaris';

interface DependentDisableBannerProps {
  info?: IRItemCard;
  dependentControls?: IDependentControl[];
}

export const DependentDisableBanner: React.FC<DependentDisableBannerProps> = ({
  info,
  dependentControls,
}) => {
  if (!info?.dependentControls?.length || !dependentControls?.length) return null;

  const disableDependency = info.dependentControls.find(
    (control) => control.action === EDependentControlAction.DISABLE,
  );

  if (!disableDependency) return null;

  const isDisabled = dependentControls.some(
    (control) => control.id === disableDependency.id && !control.value,
  );

  if (!isDisabled) return null;

  return (
    <Banner tone="info">
      <Text as="p" variant="bodySm">
        {disableDependency?.tooltip?.content}
      </Text>
    </Banner>
  );
};
